module.exports = require("@babel/parser");